module.exports = __webpack_public_path__ + "img/icon_6.83abd4d.svg";